import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M20.5937 10.2489C21.7623 11.4182 21.7624 13.3133 20.5935 14.4823C18.4976 16.5781 16.4049 18.6708 14.3105 20.7652C12.9382 22.1375 10.7134 22.1375 9.3411 20.7652C7.14063 18.5648 4.94108 16.3652 2.73968 14.1638C1.75344 13.1776 1.75344 11.5786 2.73968 10.5923C3.24023 10.0918 3.74087 9.59113 4.24269 9.08931C4.62161 8.71038 5.29925 8.77287 5.42093 9.29476C5.87275 11.2573 8.11419 12.2704 9.8844 11.305C11.4834 10.4331 11.997 8.39818 10.991 6.88389C10.5462 6.21322 9.9197 5.78434 9.13607 5.5902C8.5971 5.45546 8.53746 4.79101 8.9303 4.39816C9.33573 3.99274 9.7412 3.58727 10.1471 3.18136C11.0771 2.25132 12.585 2.25131 13.5151 3.18136C14.245 3.91129 14.976 4.64228 15.7111 5.37742C15.9829 5.64915 16.4511 5.64327 16.6723 5.329C16.9723 4.90542 17.177 4.43948 17.3164 3.93648C17.6994 2.55808 19.2049 1.83976 20.5356 2.39395C21.9758 2.99402 22.4612 4.79246 21.5046 6.05261C21.1604 6.50619 20.698 6.78152 20.1491 6.92448C19.5914 7.07273 19.0937 7.33747 18.649 7.7081C18.474 7.85341 18.4692 8.1217 18.6299 8.28268C19.2854 8.93959 19.9394 9.59431 20.5937 10.2489Z",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, null, -1)
  ]))]))
}
export default { render: render }